import { useEffect, useState } from "react";
import Button from "../../../../components/button/button";
import Label from "../../../../components/label/label";
import Input from "../../../../components/input/input";
import CustomSelect from "../../../../components/customSelect/customSelect";
import { useUserContext } from "../../../utils/userContext";

function EditUser({ user, onCancel }) {
    const { editUser, fetchUserDetail } = useUserContext();
    const [formData, setFormData] = useState({
        name: '',
        prename: '',
        email: '',
        phoneNumber: '',
        address: '',
        companyName: '',
        subscription: 'free',
        role: 'user',
        emailConfirmed: false,
        active: true,
        addressAdition: '',
        website: '',
        taxNumber: '',
        taxOffice: '',
        bank: '',
        iban: '',
        bic: '',
        town: '',
        postCode: '',
        customerStatusList: '',
        onboardCompleted: false
    });

    useEffect(() => {
        if (!user) return;

        setFormData({
            name: user.name || '',
            prename: user.prename || '',
            email: user.email || '',
            phoneNumber: user.phoneNumber || '',
            address: user.address || '',
            companyName: user.companyName || '',
            subscription: user.subscription || 'free',
            role: user.role || 'user',
            emailConfirmed: Boolean(user.emailConfirmed),
            active: user.active !== undefined ? Boolean(user.active) : true,
            addressAdition: user.addressAdition || '',
            website: user.website || '',
            taxNumber: user.taxNumber || '',
            taxOffice: user.taxOffice || '',
            bank: user.bank || '',
            iban: user.iban || '',
            bic: user.bic || '',
            town: user.town || '',
            postCode: user.postCode || '',
            customerStatusList: Array.isArray(user.customerStatusList) ? user.customerStatusList.join(', ') : '',
            onboardCompleted: Boolean(user.onboardCompleted)
        });
    }, [user]);

    const customers = user?.customers || [];
    const invoices = user?.invoices || [];

    function formatDate(dateString) {
        if (!dateString) return '';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    }

    const subscriptionOptions = [
        { id: 'free', name: 'Free' },
        { id: 'premium', name: 'Premium' }
    ];

    const roleOptions = [
        { id: 'user', name: 'User' },
        { id: 'admin', name: 'Admin' },
        { id: 'coworker', name: 'Coworker' }
    ];

    const emailConfirmedOptions = [
        { id: true, name: 'Ja' },
        { id: false, name: 'Nein' }
    ];

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (formData.active === false && user.active !== false) {
            const confirmed = window.confirm(
                'Der Account wird deaktiviert. Bitte bestätige, dass der User wirklich auf deaktiviert werden soll.'
            );
            if (!confirmed) return;
        }

        await editUser({
            name: formData.name,
            prename: formData.prename,
            email: formData.email,
            phoneNumber: formData.phoneNumber,
            address: formData.address,
            companyName: formData.companyName,
            subscription: formData.subscription,
            role: formData.role,
            emailConfirmed: formData.emailConfirmed === true || formData.emailConfirmed === 'true',
            active: formData.active === true || formData.active === 'true',
            addressAdition: formData.addressAdition,
            website: formData.website,
            taxNumber: formData.taxNumber,
            taxOffice: formData.taxOffice,
            bank: formData.bank,
            iban: formData.iban,
            bic: formData.bic,
            town: formData.town,
            postCode: formData.postCode,
            customerStatusList: formData.customerStatusList
                .split(',')
                .map((status) => status.trim())
                .filter(Boolean),
            onboardCompleted: formData.onboardCompleted === true || formData.onboardCompleted === 'true'
        }, user._id);

        await fetchUserDetail(user._id);
        onCancel?.();
    };

    return (
        <div className="adUsDePageContainer">
            <div className="adUsDeContentContainer">
                <div className="adUsDeHeadingContainer"><h3>Userdaten bearbeiten</h3></div>
                <form className="adUsDeForm" onSubmit={handleSubmit}>
                    <div className="adUsDeFormRow">
                        <Label labelFor='name' labelValue='Name:' />
                        <Input
                            inputType="text"
                            inputName="name"
                            inputValue={formData.name}
                            borderColor="black"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelFor='prename' labelValue='Vorname:' />
                        <Input
                            inputType="text"
                            inputName="prename"
                            inputValue={formData.prename}
                            borderColor="black"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelFor='email' labelValue='Email:' />
                        <Input
                            inputType="email"
                            inputName="email"
                            inputValue={formData.email}
                            borderColor="black"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelFor='phoneNumer' labelValue='Telefon:' />
                        <Input
                            inputType="text"
                            inputName="phoneNumber"
                            inputValue={formData.phoneNumber}
                            borderColor="black"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelFor='address' labelValue='Adresse:' />
                        <Input
                            inputType="text"
                            inputName="address"
                            inputValue={formData.address}
                            borderColor="black"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelFor='companyName' labelValue='Firma:' />
                        <Input
                            inputType="text"
                            inputId="companyName"
                            inputName="companyName"
                            inputValue={formData.companyName}
                            borderColor="black"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelFor='addressAdition' labelValue='Adresszusatz:' />
                        <Input
                            inputType="text"
                            inputId="addressAdition"
                            inputName="addressAdition"
                            inputValue={formData.addressAdition}
                            borderColor="black"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelFor='town' labelValue='Stadt:' />
                        <Input
                            inputType="text"
                            inputId="town"
                            inputName="town"
                            inputValue={formData.town}
                            borderColor="black"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelFor='postCode' labelValue='Postleitzahl:' />
                        <Input
                            inputType="text"
                            inputId="postCode"
                            inputName="postCode"
                            inputValue={formData.postCode}
                            borderColor="black"
                            onChange={handleChange}
                            maxLength={10}
                        />
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelFor='website' labelValue='Website:' />
                        <Input
                            inputType="text"
                            inputId="website"
                            inputName="website"
                            inputValue={formData.website}
                            borderColor="black"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelFor='bank' labelValue='Bank:' />
                        <Input
                            inputType="text"
                            inputId="bank"
                            inputName="bank"
                            inputValue={formData.bank}
                            borderColor="black"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelFor='iban' labelValue='IBAN:' />
                        <Input
                            inputType="text"
                            inputId="iban"
                            inputName="iban"
                            inputValue={formData.iban}
                            borderColor="black"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelFor='bic' labelValue='BIC:' />
                        <Input
                            inputType="text"
                            inputId="bic"
                            inputName="bic"
                            inputValue={formData.bic}
                            borderColor="black"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelFor='taxNumber' labelValue='Steuernummer:' />
                        <Input
                            inputType="text"
                            inputId="taxNumber"
                            inputName="taxNumber"
                            inputValue={formData.taxNumber}
                            borderColor="black"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelFor='taxOffice' labelValue='Finanzamt:' />
                        <Input
                            inputType="text"
                            inputId="taxOffice"
                            inputName="taxOffice"
                            inputValue={formData.taxOffice}
                            borderColor="black"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelFor='customerStatusList' labelValue='Kundenstatusliste (Komma getrennt):' />
                        <Input
                            inputType="text"
                            inputId="customerStatusList"
                            inputName="customerStatusList"
                            inputValue={formData.customerStatusList}
                            borderColor="black"
                            onChange={handleChange}
                            placeholder="Neu, Kunde, Lost"
                        />
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelValue='Abo:' />
                        <CustomSelect
                            items={subscriptionOptions}
                            selected={subscriptionOptions.find((option) => option.id === formData.subscription)}
                            setSelected={(value) => setFormData((prev) => ({ ...prev, subscription: value.id }))}
                            displayKey="name"
                            idKey="id"
                            placeholder="Abo wählen"
                            valueType="object"
                            search={false}
                        />
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelValue='User:' />
                        <CustomSelect
                            items={roleOptions}
                            selected={roleOptions.find((option) => option.id === formData.role)}
                            setSelected={(value) => setFormData((prev) => ({ ...prev, role: value.id }))}
                            displayKey="name"
                            idKey="id"
                            placeholder="Rolle wählen"
                            valueType="object"
                            search={false}
                        />
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelValue='Email bestätigt:' />
                        <CustomSelect
                            items={emailConfirmedOptions}
                            selected={formData.emailConfirmed}
                            setSelected={(value) => setFormData((prev) => ({ ...prev, emailConfirmed: value }))}
                            displayKey="name"
                            idKey="id"
                            placeholder="Bestätigung wählen"
                            valueType="primitive"
                            search={false}
                        />
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelValue='Account aktiv:' />
                        <CustomSelect
                            items={emailConfirmedOptions}
                            selected={formData.active}
                            setSelected={(value) => setFormData((prev) => ({ ...prev, active: value }))}
                            displayKey="name"
                            idKey="id"
                            placeholder="Aktiv wählen"
                            valueType="primitive"
                            search={false}
                        />
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelValue='Onboarding abgeschlossen:' />
                        <CustomSelect
                            items={emailConfirmedOptions}
                            selected={formData.onboardCompleted}
                            setSelected={(value) => setFormData((prev) => ({ ...prev, onboardCompleted: value }))}
                            displayKey="name"
                            idKey="id"
                            placeholder="Status wählen"
                            valueType="primitive"
                            search={false}
                        />
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelValue='Angemeldet am:' />
                        <p>{formatDate(user.signedUpAt)}</p>
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelValue='Kunden:' />
                        <p>{customers.length}</p>
                    </div>
                    <div className="adUsDeFormRow">
                        <Label labelValue='Rechnungen:' />
                        <p>{invoices.length}</p>
                    </div>
                    <div className="adUsDeFormActions">
                        <Button buttonValue="Abbrechen" onClick={(e) => { e.preventDefault(); onCancel?.(); }} />
                        <Button buttonType="submit" buttonValue="Speichern" />
                    </div>
                </form>
            </div>
        </div>
    );
}

export default EditUser;
